var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "outer-wrapper" }, [
    _c("div", { staticClass: "coupon-wrapper" }, [
      _c("div", { staticClass: "coupon-title" }, [
        _vm._v("Have a coupon code?"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "coupon-input-wrapper" }, [
        _c("label", { staticClass: "coupon-label" }, [_vm._v("Code")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.couponName,
              expression: "couponName",
            },
          ],
          class: [{ couponCodeApplied: _vm.readOnlyCoupon }, "coupon-code"],
          attrs: {
            type: "text",
            id: "coupon-code",
            placeholder: "123SSAVE",
            "aria-label": _vm.readOnlyCoupon
              ? "Coupon code " + _vm.couponName
              : "Enter coupon code.",
            readonly: _vm.readOnlyCoupon,
          },
          domProps: { value: _vm.couponName },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) return
                _vm.couponName = $event.target.value
              },
              function ($event) {
                return _vm.$emit("input", $event.target.value)
              },
            ],
          },
        }),
        _vm._v(" "),
        _vm.readOnlyCoupon
          ? _c(
              "button",
              {
                attrs: {
                  id: "remove-coupon",
                  "aria-label": "Remove coupon code " + _vm.couponName,
                },
                on: {
                  click: function ($event) {
                    return _vm.removeCoupon()
                  },
                },
              },
              [_vm._v("\n\t\t\t\tRemove\n\t\t\t")]
            )
          : _c(
              "button",
              {
                attrs: {
                  id: "apply-coupon",
                  "aria-label": "Submit coupon code " + _vm.couponName,
                },
                on: {
                  click: function ($event) {
                    return _vm.applyCoupon()
                  },
                },
              },
              [_vm._v("\n\t\t\t\tApply\n\t\t\t")]
            ),
      ]),
    ]),
    _vm._v(" "),
    _vm.error
      ? _c(
          "div",
          { staticClass: "error" },
          [
            _c(
              "icon-base",
              {
                staticClass: "error-icon",
                attrs: { width: "15px", height: "15px", iconName: "Error" },
              },
              [_c("icon-exclamation")],
              1
            ),
            _vm._v(" "),
            _c("span", { staticClass: "error-text" }, [
              _vm._v(_vm._s(_vm.error)),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }